module.exports = __webpack_public_path__ + "img/mount1.9ba842d2.jpg";